$(document).ready(function () {
  const nav = $('#nav')
  //实现滚动效果
  nav.find('.item4').on('click', function () {
    $('html,body').animate(
      {
        scrollTop: 0,
      },
      500
    )
  })
  //显示二维码
  nav.find('.item3').hover(function () {
    $('#nav .out').toggle()
  })
  // 在线咨询跳转
  nav.find('.item5').on('click', function () {
    window.open(
      'http://p.qiao.baidu.com/cps/chat?siteId=12909305&userId=11134406&siteToken=b4f8f59b22d93e143bec6f3cf289abee',
      '_blank',
      'toolbar=yes,location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=800, height=600'
    )
  })

  $(window).scroll(function () {
    // console.log($(document).scrollTop())
    let topto = $(document).scrollTop()
    if (topto >= 900) {
      nav.find('.item4').show()
    } else {
      nav.find('.item4').hide()
    }
  })
  // nav.find('.btnto').on('click', function () {
  //   window.open($.getEnv().teacherUrl)
  // })
})
